import { PERMISSION_LABELS, PERMISSIONS } from '@gl/shared';

import { useCurrentUser } from '../auth.js';
import { LoginPrompt } from '../components/states.js';

export function SettingsPage() {
  const user = useCurrentUser();

  if (!user) {
    return (
      <div>
        <div className="page-head">
          <p className="eyebrow mb-1">Your account</p>
          <h1 className="page-title">Settings</h1>
        </div>
        <LoginPrompt>Log in to see your account settings.</LoginPrompt>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-2xl">
      <div className="page-head">
        <p className="eyebrow mb-1">Your account</p>
        <h1 className="page-title">Settings</h1>
      </div>

      <section className="card mb-6">
        <h2 className="mb-4 font-display text-xl font-bold uppercase tracking-tight text-field-50">
          Account
        </h2>
        <dl className="space-y-3 text-sm">
          <div className="flex justify-between gap-4">
            <dt className="text-field-400">Name</dt>
            <dd className="text-field-100">{user.displayName}</dd>
          </div>
          <div className="flex justify-between gap-4">
            <dt className="text-field-400">Email</dt>
            <dd className="text-field-100">{user.email}</dd>
          </div>
          <div className="flex justify-between gap-4">
            <dt className="text-field-400">Google name</dt>
            <dd className="text-field-100">{user.googleName}</dd>
          </div>
          <div className="flex justify-between gap-4">
            <dt className="text-field-400">Sleeper account</dt>
            <dd className="text-field-100">{user.sleeperUserId ?? 'Not linked'}</dd>
          </div>
        </dl>
        <p className="mt-4 text-xs text-field-500">
          {user.sleeperUserId
            ? 'The site calls you by your Sleeper name. Your picture comes from your Google account.'
            : 'Your name and picture come from your Google account; once a commissioner links you to a Sleeper member the site will call you by that name instead.'}{' '}
          Ask a commissioner to change which Sleeper team you are linked to.
        </p>
      </section>

      <section className="card">
        <h2 className="mb-4 font-display text-lg font-semibold text-field-50">What you can do</h2>
        <ul className="space-y-2 text-sm">
          {PERMISSIONS.map((permission) => {
            const granted =
              user.permissions.includes(permission) || user.permissions.includes('admin');
            return (
              <li key={permission} className="flex items-center gap-2">
                <span className={granted ? 'text-emerald-400' : 'text-field-600'}>
                  {granted ? '✓' : '·'}
                </span>
                <span className={granted ? 'text-field-200' : 'text-field-500'}>
                  {PERMISSION_LABELS[permission]}
                </span>
              </li>
            );
          })}
        </ul>
      </section>
    </div>
  );
}
